const namespace = 'PARK/CURRENT_PARK/';

export const SELECT_CHANNEL = namespace + 'SELECT_CHANNEL';
export const SELECT_DATE = namespace + 'SELECT_DATE';
export const SELECT_PARK = namespace + 'SELECT_PARK';
